module.exports = __webpack_public_path__ + "assets/img/end_2.dc8c72d3.png";